type TrackingProps = {
  action?: string
  category?: string
  label?: string
  value?: number
}

/** @deprecated No-op. Product analytics events are not collected. */
export const trackAnalyticsEvent = (_props: TrackingProps) => {}

/** @deprecated No-op. Product analytics events are not collected. */
export const trackClickEvent = (_label: string) => {}

/** @deprecated No-op. Product analytics events are not collected. */
export const useImpressionTracking = (
  _props: Omit<TrackingProps, 'action'>,
) => {}
